import service from "@/store/services/sales-payments-service";

export const state = {
  list: {},
  salesPayment: {},
  meta: {},
};

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, salesPayment) => {
    state.salesPayment = salesPayment;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((salesPayment) => {
      commit("SET_RESOURCE", salesPayment);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((salesPayment) => {
      commit("SET_RESOURCE", salesPayment);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((salesPayment) => {
      commit("SET_RESOURCE", salesPayment);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  salesPayment: (state) => state.salesPayment,
};

const salesPayments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default salesPayments;
